export default "__VITE_ASSET__2ctCoIOa__"